module.exports = __webpack_public_path__ + "static/media/bell.b56a3b64.svg";